const types = [
    // ["", 'signup.form.profilType'],
    ["PP", "projectHolder"],
    ["BF", "donor"],
    ["ACMPT", "accompanyingPerson"],
    ["visitor", "visitor"],
];

export default types;